// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dZVz","right":"Footer_right__2bxNV","buttons":"Footer_buttons__igxrI"};